import { render } from "./TriggeringElement.vue?vue&type=template&id=8bbf6768"
import script from "./TriggeringElement.vue?vue&type=script&lang=js"
export * from "./TriggeringElement.vue?vue&type=script&lang=js"

import "./TriggeringElement.vue?vue&type=style&index=0&id=8bbf6768&lang=css"
script.render = render

export default script